import React, { useEffect, useState } from 'react';
import { CircularProgress, Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import SubscriptionForm from '../components/SubscriptionForm';
import { useGetSubscriptionHandler } from '../dataHandlers/getSubscriptionHandler';
import { useMutateSubscriptionHandler } from '../dataHandlers/mutateSubscriptionHandler';

export default function SubscriptionEditPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { subscription, isLoading: isLoadingData } = useGetSubscriptionHandler(id);
  const { onSubmit, error, isPending } = useMutateSubscriptionHandler({
    onSuccess: () => navigate('/subscriptions'),
  });

  useEffect(() => {
    if (!isPending && isSubmitting) setIsSubmitting(false);
  }, [isPending, isSubmitting]);

  if (isLoadingData || !subscription) return <CircularProgress />;

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <SubscriptionForm
        onSubmit={(payload) =>
          onSubmit({ ...payload, stripe_subscription_id: subscription.stripe_subscription_id }, true)
        }
        onCancel={() => navigate('/subscriptions')}
        initialData={subscription}
        apiErrors={error}
        isLoading={isPending || isLoadingData || isSubmitting}
        isEditMode
      />
    </Stack>
  );
}
